import { uid } from "./uid-generate";

export function replaceIdsWithUids(
  input,
  preserveOriginal = false,
  inSettings = false,
  groupIdMap = new Map(),
  idMap = new Map() // глобальная мапа для стабильности id
) {
  if (Array.isArray(input)) {
    return input.map(item =>
      replaceIdsWithUids(item, preserveOriginal, inSettings, groupIdMap, idMap)
    );
  }

  if (input && typeof input === "object") {
    const acc = {};

    for (const key in input) {
      if (!input.hasOwnProperty(key)) continue;

      // Пропускаем id внутри settings
      if (inSettings && key === "id") {
        acc.id = input[key];
        continue;
      }

      // Верхний id группы, если помечен
      if (key === "id" && input._isGroupId === true) {
        const originalId = input[key];
        let stableId = groupIdMap.get(originalId);
        if (!stableId) {
          stableId = uid();
          groupIdMap.set(originalId, stableId);
        }

        if (preserveOriginal) acc.originalId = originalId;
        acc.id = stableId;
        continue;
      }

      // Объекты group
      if (key === "group" && input[key] && typeof input[key] === "object") {
        const oldGroupId = input[key].id;
        let newGroupId = groupIdMap.get(oldGroupId);
        if (!newGroupId) {
          newGroupId = uid();
          groupIdMap.set(oldGroupId, newGroupId);
        }

        acc[key] = {
          ...input[key],
          id: newGroupId,
          settings: input[key].settings
            ? replaceIdsWithUids(input[key].settings, preserveOriginal, true, groupIdMap, idMap)
            : input[key].settings,
        };
        continue;
      }

      // Все остальные id элементов
      if (key === "id") {
        const originalId = input[key];
        let stableId = idMap.get(originalId);
        if (!stableId) {
          stableId = uid();
          idMap.set(originalId, stableId);
        }

        if (preserveOriginal) acc.originalId = originalId;
        acc.id = stableId;
        continue;
      }

      // Рекурсивно обрабатываем settings с флагом
      if (key === "settings" && input[key] && typeof input[key] === "object") {
        acc[key] = replaceIdsWithUids(input[key], preserveOriginal, true, groupIdMap, idMap);
        continue;
      }

      // Рекурсивно обрабатываем children и массивы data
      if ((key === "children" || key === "data") && input[key]) {
        acc[key] = replaceIdsWithUids(input[key], preserveOriginal, false, groupIdMap, idMap);
        continue;
      }

      // Остальное рекурсивно
      acc[key] = replaceIdsWithUids(input[key], preserveOriginal, inSettings, groupIdMap, idMap);
    }

    return acc;
  }

  return input;
}
